export default __webpack_public_path__ + "static/media/658.f82beab1.png";